import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon36: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        d="M13.314.036A.5.5 0 0 1 14 .5v12a.5.5 0 0 1-.686.465L9 11.238V14a2 2 0 0 1-1.851 1.995L7 16a2 2 0 0 1-2-2V9.638L3.404 9H.5a.5.5 0 0 1-.492-.41L0 8.5v-4A.5.5 0 0 1 .5 4h2.904l9.91-3.964ZM6 10.038V14a1 1 0 1 0 2 0v-3.162l-2-.8Zm7-8.8-9 3.6v3.324l9 3.6V1.239ZM3 5H1v3h2V5Zm12.5 2.006h4a.5.5 0 1 0 0-1h-4a.5.5 0 0 0 0 1Zm.357-2.151 2.997-3.005a.5.5 0 0 0-.708-.707l-2.997 3.005a.5.5 0 0 0 .708.707Zm-.71 4.002 3 2.993a.5.5 0 0 0 .706-.707l-3-2.994a.5.5 0 0 0-.706.708Z"
      />
    </Svg>
  )
}
